import React from "react";
import Portfolios from "Components/ListView/Portfolios";

const Homepage = () => {
    return (
        <div>
            <Portfolios />
        </div>
    );
};

export default Homepage;
